
import type { GlobalOptionsKey, ValidFieldListTypes, BlockBundleWithNested } from './generated-types'
import type { BlockDefinitionInput, BlockDefinitionOptionsInput, FragmentDefinitionInput } from '../../node_modules/@blokkli/editor/dist/runtime/types/index.ts'
export const globalOptions = {
  "bkVisibleLanguages": {
    "type": "checkboxes",
    "label": "Visible languages",
    "options": {},
    "default": []
  },
  "bkHiddenGlobally": {
    "type": "checkbox",
    "label": "Global verstecken",
    "default": false,
    "group": "Advanced"
  },
  "publicationChannels": {
    "type": "checkboxes",
    "label": "Publication Channel",
    "default": [
      "app",
      "web"
    ],
    "group": "Advanced",
    "options": {
      "app": "App",
      "web": "Web"
    }
  },
  "showAnchor": {
    "type": "checkbox",
    "label": "In Anker-Navigation anzeigen",
    "default": false
  },
  "contextToggleId": {
    "type": "text",
    "label": "Toggle ID",
    "default": "",
    "group": "Advanced"
  },
  "isHero": {
    "type": "checkbox",
    "label": "Als Hero (16:9) anzeigen",
    "default": false
  }
} as const

type DefinitionItem = BlockDefinitionInput<BlockDefinitionOptionsInput, GlobalOptionsKey[]>

const BlokkliComponent_tomas_index: DefinitionItem = {
  bundle: 'tomas',
  chunkName: 'rare',
}
const BlokkliComponent_from_library_index: DefinitionItem = {
  bundle: 'from_library',
}
const BlokkliComponent_accordion_InsideFooter: DefinitionItem = {
  bundle: 'accordion',
  globalOptions: ['bkHiddenGlobally', 'publicationChannels'],
  renderFor: {
    fieldListType: 'footer',
  },
}
const BlokkliComponent_accordion_index: DefinitionItem = {
  bundle: 'accordion',
  globalOptions: ['bkHiddenGlobally', 'publicationChannels'],
}
const BlokkliComponent_address_index: DefinitionItem = {
  bundle: 'address',
  globalOptions: ['bkHiddenGlobally', 'publicationChannels'],
}
const BlokkliComponent_address_list_index: DefinitionItem = {
  bundle: 'address_list',
  globalOptions: ['bkHiddenGlobally', 'publicationChannels'],
  options: {
    addressListStyle: {
      type: 'radios',
      label: 'Style',
      default: 'map',
      options: {
        map: 'Map',
      },
    },
  },
}
const BlokkliComponent_datawrapper_index: DefinitionItem = {
  bundle: 'datawrapper',
  globalOptions: ['bkHiddenGlobally', 'publicationChannels'],
}
const BlokkliComponent_dynamics_365_index: DefinitionItem = {
  bundle: 'dynamics_365',
  globalOptions: ['bkHiddenGlobally', 'publicationChannels'],
}
const BlokkliComponent_faq_index: DefinitionItem = {
  bundle: 'faq',
}
const BlokkliComponent_guidle_index: DefinitionItem = {
  bundle: 'guidle',
  globalOptions: ['bkHiddenGlobally', 'publicationChannels'],
}
const BlokkliComponent_iframe_index: DefinitionItem = {
  bundle: 'iframe',
  globalOptions: ['bkHiddenGlobally', 'publicationChannels'],
}
const BlokkliComponent_image_InsideSlider: DefinitionItem = {
  bundle: 'image',
  globalOptions: ['bkHiddenGlobally', 'publicationChannels'],
  // This renders the component when the parent is the slider.
  renderFor: {
    parentBundle: 'slider',
  },
}
const BlokkliComponent_image_index: DefinitionItem = {
  bundle: 'image',
  globalOptions: [
    'isHero',
    'contextToggleId',
    'bkHiddenGlobally',
    'publicationChannels',
  ],
  editor: {
    determineVisibleOptions: function (ctx) {
      if (ctx.parentType) {
        return ['contextToggleId', 'bkHiddenGlobally', 'publicationChannels']
      }

      return [
        'isHero',
        'contextToggleId',
        'bkHiddenGlobally',
        'publicationChannels',
      ]
    },
  },
}
const BlokkliComponent_link_AsSocialLinks: DefinitionItem = {
  bundle: 'link',
  globalOptions: ['bkHiddenGlobally'],
  renderFor: {
    fieldListType: 'socialLinks',
  },
}
const BlokkliComponent_link_index: DefinitionItem = {
  bundle: 'link',
  globalOptions: ['bkHiddenGlobally', 'publicationChannels'],
}
const BlokkliComponent_issuu_index: DefinitionItem = {
  bundle: 'issuu',
  globalOptions: ['bkHiddenGlobally', 'publicationChannels'],
}
const BlokkliComponent_logo_index: DefinitionItem = {
  bundle: 'logo',
  globalOptions: ['bkHiddenGlobally'],
}
const BlokkliComponent_quote_index: DefinitionItem = {
  bundle: 'quote',
  globalOptions: ['bkHiddenGlobally', 'publicationChannels'],
}
const BlokkliComponent_logo_list_index: DefinitionItem = {
  bundle: 'logo_list',
  globalOptions: ['bkHiddenGlobally'],
}
const BlokkliComponent_remote_video_index: DefinitionItem = {
    bundle: 'remote_video',
    globalOptions: [
      'isHero',
      'contextToggleId',
      'bkHiddenGlobally',
      'publicationChannels',
    ],
    options: {
      isModal: {
        type: 'checkbox',
        label: 'Open video in Modal',
        default: false,
      },
    },
  }
const BlokkliComponent_slider_index: DefinitionItem = {
  bundle: 'slider',
  globalOptions: ['bkHiddenGlobally', 'publicationChannels'],
  editor: {
    disableEdit: true,
  },
}
const BlokkliComponent_teaser_InsideMenu: DefinitionItem = {
  bundle: 'teaser',
  globalOptions: ['bkHiddenGlobally'],
  renderFor: {
    fieldListType: 'menu',
  },
  editor: {
    previewWidth: 200,
  },
}
const BlokkliComponent_teaser_index: DefinitionItem = {
  bundle: 'teaser',
  globalOptions: ['bkHiddenGlobally', 'publicationChannels'],
  options: {
    teaserMedia: {
      type: 'radios',
      label: 'Teaser Media',
      default: 'media',
      group: 'Advanced',
      options: {
        media: 'Media',
        zurichCard: 'Zürich Card',
      },
    },
    showOpeningHours: {
      type: 'checkbox',
      label: 'Show opening hours',
      default: true,
    },
  },

  editor: {
    previewWidth: 800,
  },
}
const BlokkliComponent_text_InsideSlider: DefinitionItem = {
  bundle: 'text',
  // This renders the component when the parent is the slider.
  renderFor: {
    parentBundle: 'slider',
  },
  options: {
    isHighlighted: {
      type: 'checkbox',
      label: 'Highlighted',
      default: false,
    },
  },
}
const BlokkliComponent_text_index: DefinitionItem = {
  bundle: 'text',
  globalOptions: ['bkHiddenGlobally', 'publicationChannels'],
  options: {
    isHighlighted: {
      type: 'checkbox',
      label: 'Hervorgehoben',
      default: false,
    },
    twoColumns: {
      type: 'checkbox',
      label: 'Zwei Spalten',
      default: false,
    },
  },
  editor: {
    addBehaviour: 'no-form',
    previewWidth: 800,
    determineVisibleOptions: function (ctx) {
      if (ctx.parentType) {
        return ['isHighlighted', 'bkHiddenGlobally', 'publicationChannels']
      }
      return [
        'isHighlighted',
        'twoColumns',
        'publicationChannels',
        'bkHiddenGlobally',
      ]
    },
  },
}
const BlokkliComponent_text_image_box_index: DefinitionItem = {
  bundle: 'text_image_box',
  globalOptions: ['bkHiddenGlobally', 'publicationChannels'],
  options: {
    isNumbered: {
      type: 'checkbox',
      label: 'Numbered',
      default: false,
    },
    isFlipped: {
      type: 'checkbox',
      label: 'Flip Alignment',
      default: false,
    },
  },
  editor: {
    disableEdit: true,
  },
}
const BlokkliComponent_teaser_list_index: DefinitionItem = {
    bundle: 'teaser_list',
    globalOptions: [
      'contextToggleId',
      'bkHiddenGlobally',
      'publicationChannels',
    ],
    options: {
      teaserStyle: {
        type: 'radios',
        label: 'Style',
        default: 'grid',
        options: {
          grid: 'Grid',
          slider: 'Slider',
          hero: 'Hero',
        },
      },
      teaserColumns: {
        type: 'radios',
        label: 'Columns',
        default: 'fifth',
        options: {
          fifth: '20%',
          quarter: '25%',
          third: '33%',
          half: '50%',
          full: 'Full',
        },
      },

      isDivided: {
        type: 'checkbox',
        label: 'Divided',
        default: false,
      },
      isNumbered: {
        type: 'checkbox',
        label: 'Numbered',
        default: false,
      },
      showMap: {
        type: 'checkbox',
        label: 'Show Map',
        default: false,
      },
    },
    editor: {
      disableEdit: true,
      determineVisibleOptions: function (ctx) {
        if (ctx.parentType === 'accordion') {
          return [
            'bkHiddenGlobally',
            'contextToggleId',
            'bkHiddenGlobally',
            'publicationChannels',
            'teaserColumns',
          ]
        }

        if (
          ctx.options.teaserStyle === 'slider' ||
          ctx.options.teaserStyle === 'hero'
        ) {
          return [
            'teaserStyle',
            'contextToggleId',
            'bkHiddenGlobally',
            'publicationChannels',
          ]
        }

        if (ctx.options.teaserColumns === 'full') {
          return [
            'teaserColumns',
            'isNumbered',
            'isDivided',
            'showMap',
            'teaserStyle',
            'contextToggleId',
            'bkHiddenGlobally',
            'publicationChannels',
          ]
        }

        return [
          'teaserColumns',
          'showMap',
          'teaserStyle',
          'contextToggleId',
          'bkHiddenGlobally',
          'publicationChannels',
        ]
      },
    },
  }
const BlokkliComponent_title_index: DefinitionItem = {
  bundle: 'title',
  globalOptions: ['showAnchor', 'bkHiddenGlobally', 'publicationChannels'],
  options: {
    anchorOnly: {
      type: 'checkbox',
      label: 'Nur in Anker anzeigen',
      default: false,
      group: 'Advanced',
    },
  },
  editor: {
    previewWidth: 800,
    determineVisibleOptions(ctx) {
      if (ctx.options.showAnchor) {
        return [
          'showAnchor',
          'anchorOnly',
          'bkHiddenGlobally',
          'publicationChannels',
        ]
      }
      return ['showAnchor', 'bkHiddenGlobally', 'publicationChannels']
    },
  },
}
const BlokkliComponent_toggle_index: DefinitionItem = {
  bundle: 'toggle',
  globalOptions: ['bkHiddenGlobally', 'publicationChannels'],
}
const BlokkliComponent_toggle_item_index: DefinitionItem = {
  bundle: 'toggle_item',
}
const BlokkliComponent_two_columns_index: DefinitionItem = {
  bundle: 'two_columns',
  globalOptions: ['bkHiddenGlobally', 'publicationChannels'],
  options: {
    grid: {
      type: 'radios',
      label: 'Widths',
      default: 'half',
      displayAs: 'grid',
      options: {
        half: {
          columns: [1, 1],
          label: 'Half',
        },
        quarter_1_3: {
          columns: [1, 3],
          label: 'Quarter',
        },
        quarter_3_1: {
          columns: [3, 1],
          label: 'Quarter',
        },
      },
    },
  },
  editor: {
    disableEdit: true,
  },
}
const BlokkliComponent_webcam_index: DefinitionItem = {
  bundle: 'webcam',
  globalOptions: ['bkHiddenGlobally', 'publicationChannels'],
}
const BlokkliComponent_video_index: DefinitionItem = {
  bundle: 'video',
  globalOptions: ['isHero', 'bkHiddenGlobally', 'publicationChannels'],
}
const BlokkliComponent_webform_index: DefinitionItem = {
  bundle: 'webform',
  chunkName: 'rare',
  globalOptions: ['bkHiddenGlobally', 'publicationChannels'],
}
const BlokkliComponent_blokkli_fragment_index: DefinitionItem = {
  bundle: 'blokkli_fragment',
  editor: {
    disableEdit: true,
  },
}

export const icons: Record<string, string> = {"accordion":"<svg xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 24 24\"><title>arrow-down-bold-box</title><path d=\"M5,3H19A2,2 0 0,1 21,5V19A2,2 0 0,1 19,21H5A2,2 0 0,1 3,19V5A2,2 0 0,1 5,3M12,17L17,12H14V8H10V12H7L12,17Z\" /></svg>\n","address":"<svg xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 24 24\"><title>map-marker</title><path d=\"M12,11.5A2.5,2.5 0 0,1 9.5,9A2.5,2.5 0 0,1 12,6.5A2.5,2.5 0 0,1 14.5,9A2.5,2.5 0 0,1 12,11.5M12,2A7,7 0 0,0 5,9C5,14.25 12,22 12,22C12,22 19,14.25 19,9A7,7 0 0,0 12,2Z\" /></svg>\n","address_list":"<svg xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 24 24\"><title>map</title><path d=\"M15,19L9,16.89V5L15,7.11M20.5,3C20.44,3 20.39,3 20.34,3L15,5.1L9,3L3.36,4.9C3.15,4.97 3,5.15 3,5.38V20.5A0.5,0.5 0 0,0 3.5,21C3.55,21 3.61,21 3.66,20.97L9,18.9L15,21L20.64,19.1C20.85,19 21,18.85 21,18.62V3.5A0.5,0.5 0 0,0 20.5,3Z\" /></svg>\n","datawrapper":"<svg xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 24 24\"><title>chart-bell-curve-cumulative</title><path d=\"M4 19V20H22V22H2V2H4V17C7 17 10 15 12.1 11.4C15.1 6.4 18.4 4 22 4V6C19.2 6 16.5 8.1 13.9 12.5C11.3 16.6 7.7 19 4 19Z\" /></svg>\n","dynamics_365":"<svg xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 24 24\"><title>microsoft-dynamics-365</title><path d=\"M6,2L17.25,8.5L13.5,11.5L6,8V2M6,9L9.5,11.25L6,22L18,9V15L6,22V9Z\" /></svg>\n","faq":"<svg viewBox=\"0 -0.06 33.834 33.834\" xmlns=\"http://www.w3.org/2000/svg\">\n    <path d=\"M15.217 15.309a2.38 2.38 0 0 1 .489-1.434 9.29 9.29 0 0 1 1.443-1.482 10.139 10.139 0 0 0 1.321-1.372 1.985 1.985 0 0 0 .368-1.2 1.956 1.956 0 0 0-1.983-2 2.073 2.073 0 0 0-1.419.543 3.575 3.575 0 0 0-.954 1.582l-2.152-.939a5.029 5.029 0 0 1 1.724-2.656 4.626 4.626 0 0 1 2.9-.927 4.968 4.968 0 0 1 2.287.531 4.168 4.168 0 0 1 1.651 1.495 3.974 3.974 0 0 1 .612 2.175 3.688 3.688 0 0 1-.538 1.965 8.8 8.8 0 0 1-1.639 1.865 13.862 13.862 0 0 0-1.358 1.322 1.536 1.536 0 0 0-.379 1 2.85 2.85 0 0 0 .1.667h-2.2a2.737 2.737 0 0 1-.273-1.135Zm1.467 6.968a1.851 1.851 0 0 1-1.357-.543 1.831 1.831 0 0 1-.551-1.359 1.875 1.875 0 0 1 .551-1.372 1.835 1.835 0 0 1 1.357-.556 1.87 1.87 0 0 1 1.909 1.928 1.834 1.834 0 0 1-.55 1.359 1.857 1.857 0 0 1-1.359.543Z\"/>\n    <path d=\"M1.474 33.717a1.475 1.475 0 0 1-.626-.14A1.459 1.459 0 0 1 0 32.244V3.572A3.576 3.576 0 0 1 3.572 0h26.69a3.576 3.576 0 0 1 3.572 3.572v20.416a3.576 3.576 0 0 1-3.572 3.571H10.29a2.555 2.555 0 0 0-1.637.594l-6.24 5.22a1.467 1.467 0 0 1-.939.344ZM3.572 2A1.574 1.574 0 0 0 2 3.572V31.11l5.37-4.491a4.561 4.561 0 0 1 2.92-1.06h19.972a1.573 1.573 0 0 0 1.572-1.571V3.572A1.574 1.574 0 0 0 30.262 2Z\"/>\n</svg>\n","guidle":"<svg xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 24 24\"><title>calendar</title><path d=\"M19,19H5V8H19M16,1V3H8V1H6V3H5C3.89,3 3,3.89 3,5V19A2,2 0 0,0 5,21H19A2,2 0 0,0 21,19V5C21,3.89 20.1,3 19,3H18V1M17,12H12V17H17V12Z\" /></svg>\n","iframe":"<svg xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 24 24\"><title>application-brackets-outline</title><path d=\"M9.5,8.5L11,10L8,13L11,16L9.5,17.5L5,13L9.5,8.5M14.5,17.5L13,16L16,13L13,10L14.5,8.5L19,13L14.5,17.5M21,2H3A2,2 0 0,0 1,4V20A2,2 0 0,0 3,22H21A2,2 0 0,0 23,20V4A2,2 0 0,0 21,2M21,20H3V6H21V20Z\" /></svg>\n","image":"<svg xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 24 24\"><title>image</title><path d=\"M8.5,13.5L11,16.5L14.5,12L19,18H5M21,19V5C21,3.89 20.1,3 19,3H5A2,2 0 0,0 3,5V19A2,2 0 0,0 5,21H19A2,2 0 0,0 21,19Z\" /></svg>\n","link":"<svg xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 24 24\"><title>link-variant</title><path d=\"M10.59,13.41C11,13.8 11,14.44 10.59,14.83C10.2,15.22 9.56,15.22 9.17,14.83C7.22,12.88 7.22,9.71 9.17,7.76V7.76L12.71,4.22C14.66,2.27 17.83,2.27 19.78,4.22C21.73,6.17 21.73,9.34 19.78,11.29L18.29,12.78C18.3,11.96 18.17,11.14 17.89,10.36L18.36,9.88C19.54,8.71 19.54,6.81 18.36,5.64C17.19,4.46 15.29,4.46 14.12,5.64L10.59,9.17C9.41,10.34 9.41,12.24 10.59,13.41M13.41,9.17C13.8,8.78 14.44,8.78 14.83,9.17C16.78,11.12 16.78,14.29 14.83,16.24V16.24L11.29,19.78C9.34,21.73 6.17,21.73 4.22,19.78C2.27,17.83 2.27,14.66 4.22,12.71L5.71,11.22C5.7,12.04 5.83,12.86 6.11,13.65L5.64,14.12C4.46,15.29 4.46,17.19 5.64,18.36C6.81,19.54 8.71,19.54 9.88,18.36L13.41,14.83C14.59,13.66 14.59,11.76 13.41,10.59C13,10.2 13,9.56 13.41,9.17Z\" /></svg>\n","issuu":"<svg viewBox=\"0.6 0.14 796.66 795.2\" xmlns=\"http://www.w3.org/2000/svg\"><path d=\"M398.92.14c220 0 398.34 177.99 398.34 397.59S618.94 795.34 398.92 795.34C178.92 795.34.6 617.33.6 397.73V33.16C.6 14.95 15.51.14 33.68.14zM125.27 392.26c-1.4 152.44 121.38 277.18 273.98 278.67 152.71 1.39 277.7-121.02 279.17-273.48 1.45-152.44-121.22-277.2-273.98-278.64-152.69-1.47-277.7 120.99-279.2 273.41zm278.12-198.25c112.07 1.1 201.76 92.49 200.83 204.18-.93 111.67-92.49 201.39-204.32 200.37-111.9-1.09-201.78-92.51-200.76-204.18 1.1-111.7 92.68-201.41 204.56-200.37zm-2.56 304.74c56.68.7 103.05-44.88 103.58-101.39.54-56.51-44.96-102.79-101.62-103.49-56.66-.53-103.05 44.88-103.56 101.46-.56 56.54 44.94 102.84 101.62 103.39z\" fill=\"currentColor\"/></svg>\n","logo":"<svg xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 24 24\"><title>domain</title><path d=\"M18,15H16V17H18M18,11H16V13H18M20,19H12V17H14V15H12V13H14V11H12V9H20M10,7H8V5H10M10,11H8V9H10M10,15H8V13H10M10,19H8V17H10M6,7H4V5H6M6,11H4V9H6M6,15H4V13H6M6,19H4V17H6M12,7V3H2V21H22V7H12Z\" /></svg>\n","quote":"<svg xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 24 24\"><title>format-quote-close</title><path d=\"M14,17H17L19,13V7H13V13H16M6,17H9L11,13V7H5V13H8L6,17Z\" /></svg>\n","logo_list":"<svg xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 24 24\"><title>dots-horizontal</title><path d=\"M16,12A2,2 0 0,1 18,10A2,2 0 0,1 20,12A2,2 0 0,1 18,14A2,2 0 0,1 16,12M10,12A2,2 0 0,1 12,10A2,2 0 0,1 14,12A2,2 0 0,1 12,14A2,2 0 0,1 10,12M4,12A2,2 0 0,1 6,10A2,2 0 0,1 8,12A2,2 0 0,1 6,14A2,2 0 0,1 4,12Z\" /></svg>\n","remote_video":"<svg xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 24 24\"><title>youtube</title><path d=\"M10,15L15.19,12L10,9V15M21.56,7.17C21.69,7.64 21.78,8.27 21.84,9.07C21.91,9.87 21.94,10.56 21.94,11.16L22,12C22,14.19 21.84,15.8 21.56,16.83C21.31,17.73 20.73,18.31 19.83,18.56C19.36,18.69 18.5,18.78 17.18,18.84C15.88,18.91 14.69,18.94 13.59,18.94L12,19C7.81,19 5.2,18.84 4.17,18.56C3.27,18.31 2.69,17.73 2.44,16.83C2.31,16.36 2.22,15.73 2.16,14.93C2.09,14.13 2.06,13.44 2.06,12.84L2,12C2,9.81 2.16,8.2 2.44,7.17C2.69,6.27 3.27,5.69 4.17,5.44C4.64,5.31 5.5,5.22 6.82,5.16C8.12,5.09 9.31,5.06 10.41,5.06L12,5C16.19,5 18.8,5.16 19.83,5.44C20.73,5.69 21.31,6.27 21.56,7.17Z\" /></svg>\n","slider":"<svg xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 24 24\"><title>view-carousel-outline</title><path d=\"M2 6H6V17H2V6M7 19H17V4H7V19M9 6H15V17H9V6M18 6H22V17H18V6Z\" /></svg>\n","teaser":"<svg xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 24 24\"><title>text-box-outline</title><path d=\"M5,3C3.89,3 3,3.89 3,5V19C3,20.11 3.89,21 5,21H19C20.11,21 21,20.11 21,19V5C21,3.89 20.11,3 19,3H5M5,5H19V19H5V5M7,7V9H17V7H7M7,11V13H17V11H7M7,15V17H14V15H7Z\" /></svg>\n","text":"<svg xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 24 24\"><title>text-long</title><path d=\"M4,5H20V7H4V5M4,9H20V11H4V9M4,13H20V15H4V13M4,17H14V19H4V17Z\" /></svg>\n","text_image_box":"<svg xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 24 24\"><title>image-text</title><path d=\"M22 13H14V11H22V13M22 7H14V9H22V7M14 17H22V15H14V17M12 9V15C12 16.1 11.1 17 10 17H4C2.9 17 2 16.1 2 15V9C2 7.9 2.9 7 4 7H10C11.1 7 12 7.9 12 9M10.5 15L8.3 12L6.5 14.3L5.3 12.8L3.5 15H10.5Z\" /></svg>\n","teaser_list":"<svg xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 24 24\"><title>view-grid</title><path d=\"M3,11H11V3H3M3,21H11V13H3M13,21H21V13H13M13,3V11H21V3\" /></svg>\n","title":"<svg xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 24 24\"><title>format-header-2</title><path d=\"M3,4H5V10H9V4H11V18H9V12H5V18H3V4M21,18H15A2,2 0 0,1 13,16C13,15.47 13.2,15 13.54,14.64L18.41,9.41C18.78,9.05 19,8.55 19,8A2,2 0 0,0 17,6A2,2 0 0,0 15,8H13A4,4 0 0,1 17,4A4,4 0 0,1 21,8C21,9.1 20.55,10.1 19.83,10.83L15,16H21V18Z\" /></svg>\n","toggle":"<svg xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 24 24\"><title>toggle-switch-off</title><path d=\"M17,7H7A5,5 0 0,0 2,12A5,5 0 0,0 7,17H17A5,5 0 0,0 22,12A5,5 0 0,0 17,7M7,15A3,3 0 0,1 4,12A3,3 0 0,1 7,9A3,3 0 0,1 10,12A3,3 0 0,1 7,15Z\" /></svg>\n","toggle_item":"<svg xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 24 24\"><title>radiobox-marked</title><path d=\"M12,20A8,8 0 0,1 4,12A8,8 0 0,1 12,4A8,8 0 0,1 20,12A8,8 0 0,1 12,20M12,2A10,10 0 0,0 2,12A10,10 0 0,0 12,22A10,10 0 0,0 22,12A10,10 0 0,0 12,2M12,7A5,5 0 0,0 7,12A5,5 0 0,0 12,17A5,5 0 0,0 17,12A5,5 0 0,0 12,7Z\" /></svg>\n","two_columns":"<svg xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 24 24\"><title>numeric-2-box</title><path d=\"M15,11C15,12.11 14.1,13 13,13H11V15H15V17H9V13C9,11.89 9.9,11 11,11H13V9H9V7H13A2,2 0 0,1 15,9M19,3H5A2,2 0 0,0 3,5V19A2,2 0 0,0 5,21H19A2,2 0 0,0 21,19V5A2,2 0 0,0 19,3Z\" /></svg>\n","webcam":"<svg xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 24 24\"><title>webcam</title><path d=\"M12,2A7,7 0 0,1 19,9A7,7 0 0,1 12,16A7,7 0 0,1 5,9A7,7 0 0,1 12,2M12,4A5,5 0 0,0 7,9A5,5 0 0,0 12,14A5,5 0 0,0 17,9A5,5 0 0,0 12,4M12,6A3,3 0 0,1 15,9A3,3 0 0,1 12,12A3,3 0 0,1 9,9A3,3 0 0,1 12,6M6,22A2,2 0 0,1 4,20C4,19.62 4.1,19.27 4.29,18.97L6.11,15.81C7.69,17.17 9.75,18 12,18C14.25,18 16.31,17.17 17.89,15.81L19.71,18.97C19.9,19.27 20,19.62 20,20A2,2 0 0,1 18,22H6Z\" /></svg>\n","video":"<svg xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 24 24\"><title>video</title><path d=\"M17,10.5V7A1,1 0 0,0 16,6H4A1,1 0 0,0 3,7V17A1,1 0 0,0 4,18H16A1,1 0 0,0 17,17V13.5L21,17.5V6.5L17,10.5Z\" /></svg>\n","webform":"<svg xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 24 24\"><title>form-textbox</title><path d=\"M17,7H22V17H17V19A1,1 0 0,0 18,20H20V22H17.5C16.95,22 16,21.55 16,21C16,21.55 15.05,22 14.5,22H12V20H14A1,1 0 0,0 15,19V5A1,1 0 0,0 14,4H12V2H14.5C15.05,2 16,2.45 16,3C16,2.45 16.95,2 17.5,2H20V4H18A1,1 0 0,0 17,5V7M2,7H13V9H4V15H13V17H2V7M20,15V9H17V15H20Z\" /></svg>\n","blokkli_fragment":"<svg xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 24 24\"><title>newspaper</title><path d=\"M20,11H4V8H20M20,15H13V13H20M20,19H13V17H20M11,19H4V13H11M20.33,4.67L18.67,3L17,4.67L15.33,3L13.67,4.67L12,3L10.33,4.67L8.67,3L7,4.67L5.33,3L3.67,4.67L2,3V19A2,2 0 0,0 4,21H20A2,2 0 0,0 22,19V3L20.33,4.67Z\" /></svg>\n"}

export const definitionsMap: Record<string, DefinitionItem> = {
  tomas: BlokkliComponent_tomas_index,
from_library: BlokkliComponent_from_library_index,
accordion__field_list_type_footer: BlokkliComponent_accordion_InsideFooter,
accordion: BlokkliComponent_accordion_index,
address: BlokkliComponent_address_index,
address_list: BlokkliComponent_address_list_index,
datawrapper: BlokkliComponent_datawrapper_index,
dynamics_365: BlokkliComponent_dynamics_365_index,
faq: BlokkliComponent_faq_index,
guidle: BlokkliComponent_guidle_index,
iframe: BlokkliComponent_iframe_index,
image__parent_block_slider: BlokkliComponent_image_InsideSlider,
image: BlokkliComponent_image_index,
link__field_list_type_socialLinks: BlokkliComponent_link_AsSocialLinks,
link: BlokkliComponent_link_index,
issuu: BlokkliComponent_issuu_index,
logo: BlokkliComponent_logo_index,
quote: BlokkliComponent_quote_index,
logo_list: BlokkliComponent_logo_list_index,
remote_video: BlokkliComponent_remote_video_index,
slider: BlokkliComponent_slider_index,
teaser__field_list_type_menu: BlokkliComponent_teaser_InsideMenu,
teaser: BlokkliComponent_teaser_index,
text__parent_block_slider: BlokkliComponent_text_InsideSlider,
text: BlokkliComponent_text_index,
text_image_box: BlokkliComponent_text_image_box_index,
teaser_list: BlokkliComponent_teaser_list_index,
title: BlokkliComponent_title_index,
toggle: BlokkliComponent_toggle_index,
toggle_item: BlokkliComponent_toggle_item_index,
two_columns: BlokkliComponent_two_columns_index,
webcam: BlokkliComponent_webcam_index,
video: BlokkliComponent_video_index,
webform: BlokkliComponent_webform_index,
blokkli_fragment: BlokkliComponent_blokkli_fragment_index
}

export const fragmentDefinitionsMap: Record<string, FragmentDefinitionInput<BlockDefinitionOptionsInput, GlobalOptionsKey[]>> = {
  anchor_navigation: {
  name: 'anchor_navigation',
  label: 'Anchor Navigation',
  description:
    'Displays an anchor navigation with links to title paragraphs on this page.',
},
countdown: {
  name: 'countdown',
  label: 'Countdown',
  chunkName: 'rare',
  options: {
    date: {
      type: 'text',
      label: 'Date (Format: YYYY-MM-DD)',
      default: '',
    },
    time: {
      type: 'text',
      label: 'Time (Format: HH:MM)',
      default: '',
    },
    showDays: {
      type: 'checkbox',
      label: 'Show days',
      default: true,
    },
    showHours: {
      type: 'checkbox',
      label: 'Show hours',
      default: true,
    },
    showMinutes: {
      type: 'checkbox',
      label: 'Show minutes',
      default: true,
    },
    showSeconds: {
      type: 'checkbox',
      label: 'Show seconds',
      default: true,
    },
  },
},
mailchimp_signup_form: {
  name: 'mailchimp_signup_form',
  label: 'Mailchimp Signup Form',
  description: 'Zeigt das Anmeldeformular für Mailchimp Newsletter an.',
  chunkName: 'rare',
  editor: {
    noPreview: true,
  },
},
ostendis_jobs: {
  name: 'ostendis_jobs',
  label: 'Ostendis Jobs',
  chunkName: 'rare',
  editor: {
    noPreview: true,
  },
},
team_list: {
  name: 'team_list',
  label: 'Team List',
  chunkName: 'rare',
  editor: {
    noPreview: true,
  },
},
tomas_shop: {
  name: 'tomas_shop',
  label: 'Tomas Shop',
  chunkName: 'rare',
  editor: {
    noPreview: true,
  },
},
tours_search_form: {
  name: 'tours_search_form',
  label: 'Tours Search Form',
  chunkName: 'rare',
  editor: {
    noPreview: true,
  },
  globalOptions: ['bkHiddenGlobally', 'publicationChannels'],
},
zurich_card_widget: {
  name: 'zurich_card_widget',
  label: 'Zurich Card Widget',
  chunkName: 'rare',
}
}

export type BlokkliFragmentName = 'anchor_navigation' | 'countdown' | 'mailchimp_signup_form' | 'ostendis_jobs' | 'team_list' | 'tomas_shop' | 'tours_search_form' | 'zurich_card_widget'

export const definitions: BlockDefinitionInput<any, GlobalOptionsKey[]>[] = Object.values(definitionsMap)
export const fragmentDefinitions: FragmentDefinitionInput<any, GlobalOptionsKey[]>[] = Object.values(fragmentDefinitionsMap)

/**
 * Get the block definition for the given field and parent context.
 */
export function getDefinition(bundle: string, fieldListType: ValidFieldListTypes, parentBundle?: BlockBundleWithNested): BlockDefinitionInput<Record<string, any>, GlobalOptionsKey[]>|undefined {
  const forFieldListType = bundle + '__field_list_type_' + fieldListType
  if (definitionsMap[forFieldListType]) {
    return definitionsMap[forFieldListType]
  }
  if (parentBundle) {
    const forParentBundle = bundle + '__parent_block_' + parentBundle
    if (definitionsMap[forParentBundle]) {
      return definitionsMap[forParentBundle]
    }
  }

  return definitionsMap[bundle]
}

/**
 * Get the definition of the default block component.
 */
export function getDefaultDefinition(bundle: string): BlockDefinitionInput<Record<string, any>, GlobalOptionsKey[]>|undefined {
  return definitionsMap[bundle]
}
export const getFragmentDefinition = (name: string): FragmentDefinitionInput<Record<string, any>, GlobalOptionsKey[]>|undefined => fragmentDefinitionsMap[name]
